import Vue from 'vue'
import { ApiClient } from '@ahaslides-product/plugins-api'
import configs from '@/config'

let resource = null

const actions = {
  getLatestLeaderboard: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/v2/latest-leaderboard/{presentationId}`,
  },

  createSlideLeaderboardInvidiual: {
    method: 'POST',
    url: `${configs.api.createLeaderboard}`,
  },
  addManualPoint: {
    method: 'POST',
    url: `${configs.baseUrl}/api/score/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const generateRandomEmoji = () => {
  return String.fromCodePoint(0x1F601 + Math.floor(Math.random() * 50))
}

const generateFakeAudiences = (count, topPoint) => {
  const audiences = []
  for (let i = count; i >= 0; i--) {
    audiences.push({
      audience: `bd2982e13e344088ad050167f49c${i}`,
      audienceName: `Audience ${i}`,
      audienceEmoji: generateRandomEmoji(),
      audienceTeam: 0,
      totalPoint: topPoint - (count - i) * topPoint * 0.02,
      index: count - i + 1,
    })
  }
  return audiences
}
export const fakeLeaderboardResp = {
  audiences: generateFakeAudiences(10, 1000),
  teams: null,
  cursor: '',
  hasNext: false,
  topAudienceStr: 'Ma',
}

const addManualPoint = async ({
  presentationId, audienceId, teamId, point, slideId,
}) => {
  const res = await resource.addManualPoint({
    presentationId, audienceId, teamId, point, slideId,
  })
  return res.body
}

const getLatestLeaderboard = async (payload, params = {}) => {
  const res = await resource.getLatestLeaderboard({
    presentationId: payload.presentationId,
    ...params,
  })
  if (res.body && res.body.audiences) {
    res.body.audiences = res.body.audiences.map((item) => {
      item.oP = item.oP || 0
      return {
        audienceName: item.aN,
        audienceEmoji: item.aE,
        audience: item.audience,
        audienceTeam: item.aT,
        totalPoint: item.tP,
        index: item.i,
        oldPoint: item.oP,
        newPoint: item.tP - item.oP,
        correctRate: item.cR,
        correctAnswersCount: item.cAc,
        streak: item.s,
        longestStreak: item.ls,
      }
    })
  }
  if (res.body && res.body.teams) {
    res.body.teams.forEach((team) => {
      team.oldPoint = team.oldPoint || 0
      team.newPoint = team.totalPoint - team.oldPoint
    })
  }
  if (res.body.countWinner === 1) {
    res.body.topAudienceStr = ''
  }
  return res.body
}

const getAggregation = (subject, teamScoringRule) => {
  if (subject === 'team') {
    if (teamScoringRule === 'average') {
      return 'average_score'
    }
    if (teamScoringRule === 'fastest') {
      return 'first_score'
    }
  }
  return 'total_score'
}

const toLeaderboardBody = (res, subject, aggregation) => {
  const items = res?.aggregations?.[aggregation]?.items || []
  const winners = items.filter((item) => item.rank === 1)
  const winnerStr = winners.map((item) => item.name).join(', ')
  if (subject === 'team') {
    return {
      teams: items.map((item) => ({
        id: item.id,
        name: item.name,
        totalPoint: item.score,
        index: item.rank,
        oldPoint: item.oldScore || 0,
        newPoint: item.score - (item.oldScore || 0),
        members: (item.members || []).map((m) => ({
          audienceName: m.name,
          audienceEmoji: m.emoji,
        })),
      })),
      countTeamWinner: winners.length,
      topTeamStr: winners.length === 1 ? '' : winnerStr,
    }
  }
  const streakLeader = res?.aggregations?.current_streak?.items?.[0]
  const longestStreakLeader = res?.aggregations?.longest_streak?.items?.[0]
  return {
    audiences: items.map((item) => ({
      audience: item.id,
      audienceName: item.name,
      audienceEmoji: item.emoji,
      totalPoint: item.score,
      index: item.rank,
      oldPoint: item.oldScore || 0,
      newPoint: item.score - (item.oldScore || 0),
    })),
    countWinner: winners.length,
    topAudienceStr: winners.length === 1 ? '' : winnerStr,
    streakLeader: streakLeader && {
      audience: streakLeader.id,
      audienceName: streakLeader.name,
      audienceEmoji: streakLeader.emoji,
      streak: streakLeader.score,
    },
    longestStreakLeader: longestStreakLeader && {
      audience: longestStreakLeader.id,
      audienceName: longestStreakLeader.name,
      audienceEmoji: longestStreakLeader.emoji,
      longestStreak: longestStreakLeader.score,
    },
  }
}

const getLeaderboardTopN = async ({
  presentationId,
  presentationVersion,
  subject,
  teamScoringRule,
  n,
}) => {
  const aggregation = getAggregation(subject, teamScoringRule)
  const client = new ApiClient(configs.kvSyncApiUrl)
  const res = await client.getLeaderboardTopN({
    presentationId,
    presentationVersion,
    subject,
    n,
    aggregation,
  })
  return toLeaderboardBody(res, subject, aggregation)
}

// Windowed over slideIds so oldScore reflects standings before the last slide.
const getLeaderboardSlideTopN = async ({
  presentationId,
  presentationVersion,
  slideIds,
  lastSlideId,
  subject,
  teamScoringRule,
  n,
}) => {
  const aggregation = getAggregation(subject, teamScoringRule)
  const client = new ApiClient(configs.kvSyncApiUrl)
  const res = await client.getLeaderboardSlideTopN({
    presentationId,
    presentationVersion,
    slideIds,
    lastSlideId,
    subject,
    n,
    aggregation,
  })
  return toLeaderboardBody(res, subject, aggregation)
}

const createSlideLeaderboardIndividual = async (payload) => {
  const res = await resource.createSlideLeaderboardInvidiual(payload)
  return res.body
}

export default {
  initResource,
  getLatestLeaderboard,
  getLeaderboardTopN,
  getLeaderboardSlideTopN,
  createSlideLeaderboardIndividual,
  addManualPoint,
}
